<template>
    <div v-if="items.length" class="fdd-sim-bar">
        <div class="fdd-sim-title">FDD 模拟返回 (仅 dev/pre 联调)</div>
        <div v-for="it in items" :key="it.kind + it.target" class="fdd-sim-item">
            <span class="fdd-sim-label">{{ it.kind === 'corp_auth' ? '企业认证' : '签署任务' }}<template v-if="it.transRef"> (合同#{{ it.transRef }})</template> · {{ statusText(it.status) }}</span>
            <el-button class="fdd-sim-btn" size="mini" type="success" @click="trigger(it, true)">成功</el-button>
            <el-button class="fdd-sim-btn" size="mini" type="danger" @click="trigger(it, false)">失败</el-button>
        </div>
    </div>
</template>

<script>
// 法大大模拟返回浮层 (需求: 法大大电子合同 V2 PRD v0.9.0 全流程联调)
// mock 模式下轮询 /fdd/sim/pending 展示等待 FDD 返回的交互 (认证中/签署中),
// 点击 成功/失败 → /fdd/mock/trigger 推进 mock 状态机并回调本服务, 流程继续;
// 环境门控双保险:
//   ① App.vue 按 VUE_APP_ENV (development/preview) 条件挂载, production 构建不渲染
//   ② /fdd/sim/pending 仅后端 mock 模式注册 (dev/pre), 线上 404 → items 恒空不显示
export default {
    name: "FddSimBar",
    data() {
        return { items: [], timer: null };
    },
    mounted() {
        this.fetchPending();
        this.timer = setInterval(this.fetchPending, 3000);
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    methods: {
        // 走 /api/fb 加密网关 (公网域名仅代理网关, 直连 /fdd/* 不可达);
        // 非 mock 模式后端返回错误 → state != 1 → items 恒空 (环境门控第二道保险)
        async fetchPending() {
            try {
                const res = await this.$request({ url: '/fdd/sim/pending', method: 'post', data: {} });
                const { state, result } = res.data || {};
                this.items = state == 1 ? ((result && result.list) || []) : [];
            } catch (_) {
                this.items = [];
            }
        },
        statusText(status) {
            return { identifying: '认证中', created: '待签署', signing: '签署中' }[status] || status;
        },
        async trigger(it, ok) {
            const action = it.kind === 'corp_auth'
                ? (ok ? 'auth_success' : 'auth_fail')
                : (ok ? 'task_finished' : 'task_failed');
            try {
                const res = await this.$request({ url: '/fdd/mock/trigger', method: 'post', data: { action, target: it.target } });
                const { state, msg } = res.data || {};
                if (state != 1) {
                    this.$message.error(msg || 'FDD 模拟触发失败');
                }
            } catch (e) {
                this.$message.error('FDD 模拟触发失败, 请重试');
            }
            this.fetchPending();
        }
    }
};
</script>

<style lang="scss" scoped>
.fdd-sim-bar {
    position: fixed;
    right: 16px;
    bottom: 16px;
    z-index: 3000; // 高于业务弹层, 保证联调/e2e 可见可点
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    padding: 8px 12px;
    max-width: 420px;

    .fdd-sim-title {
        font-size: 12px;
        color: #909399;
        margin-bottom: 4px;
    }
    .fdd-sim-item {
        display: flex;
        align-items: center;
        padding: 4px 0;

        .fdd-sim-label {
            font-size: 12px;
            color: #606266;
            margin-right: 8px;
            word-break: break-all;
        }
        .fdd-sim-btn {
            margin-left: 8px; // el-button 相邻自带 margin-left, 显式保持
        }
    }
}
</style>
